import { useLmsLessonHomeworkQuery } from 'core/graphql';

import { transformLessonAssignment } from './transform';
import type { IHomeworkAssignment, ITextbookFile } from './transform';

interface IUseLessonHomeworkAssignment {
  /** null = the lesson has no assignment yet — OR the query failed, which is
   * why callers MUST branch on `error` before trusting a null (a false
   * "нет задания" invites the teacher to create one over the real one). */
  assignment: IHomeworkAssignment | null;
  /** ТЗ 0026: учебник занятия приходит даже когда задания нет. */
  textbookFiles: ITextbookFile[];
  loading: boolean;
  error: string;
  refetch: () => void;
}

/**
 * Staff view of the lesson assignment (Teacher of the group; Methodist
 * read-only). After upsertHomeworkAssignment the mutation refetches this
 * operation by name.
 */
export const useLessonHomeworkAssignment = (lessonId: string): IUseLessonHomeworkAssignment => {
  const { data, loading, error, refetch } = useLmsLessonHomeworkQuery({
    variables: { lessonId },
    skip: !lessonId,
    fetchPolicy: 'cache-and-network',
  });

  const { assignment, textbookFiles } = transformLessonAssignment(data);

  return {
    assignment,
    textbookFiles,
    loading: loading && !data,
    error: error?.message || '',
    refetch,
  };
};
